import { useMemo } from 'react';
import { useIntl } from 'react-intl-next';
import type { IntlShapeV2 } from './types.tsx';

/**
 * @deprecated use useIntl
 */
export const useIntlV2 = () => {
	const {
		messages,
		locale,
		formats,
		formatDate,
		formatMessage,
		formatNumber,
		formatPlural,
		formatTime,
	} = useIntl();

	// Only recreate intl object if reference to originral intl changes.
	const memoisedIntl = useMemo(() => {
		const modifiedIntl: IntlShapeV2 = {
			// @ts-expect-error - TS2322 - Type 'Record<string, string> | Record<string, MessageFormatElement[]>' is not assignable to type '{ [id: string]: string; }'.
			messages,
			locale,
			formats,
			formatDate,
			formatMessage,
			formatNumber,
			formatPlural,
			formatTime,
		};

		return modifiedIntl;
	}, [
		formatDate,
		formatMessage,
		formatPlural,
		formatTime,
		formatNumber,
		formats,
		locale,
		messages,
	]);

	return memoisedIntl;
};
